export const getUserImageURL = (user_id, image_id, size = 100) => {
  return `https://cdn.discordapp.com/avatars/${user_id}/${image_id}.png?size=${size}`
}